import { HashRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { AuthBar } from './components/AuthBar'
import { RequireAllowlist } from './components/RequireAllowlist'
import { RequireAuth } from './components/RequireAuth'
import { AuthProvider } from './hooks/useAuth'
import { KnowledgeProvider } from './hooks/useKnowledge'
import { TasksProvider } from './hooks/useTasks'
import { TourProvider } from './tours/TourProvider'
import { AccountPage } from './pages/AccountPage'
import { CampaignsDemoPage } from './pages/CampaignsDemoPage'
import { DiscoveryPage } from './pages/DiscoveryPage'
import { GuestDiscoveryPage } from './pages/GuestDiscoveryPage'
import { KnowledgeDocPage } from './pages/KnowledgeDocPage'
import { KnowledgePage } from './pages/KnowledgePage'
import { LoginPage } from './pages/LoginPage'
import { NotYetPage } from './pages/NotYetPage'
import { PreviewsPage } from './pages/PreviewsPage'
import { TaskDetailPage } from './pages/TaskDetailPage'
import { TaskListPage } from './pages/TaskListPage'

function AuthedLayout() {
  return (
    <TasksProvider>
      <KnowledgeProvider>
        <TourProvider>
          <AuthBar />
          <Outlet />
        </TourProvider>
      </KnowledgeProvider>
    </TasksProvider>
  )
}

export default function App() {
  return (
    <HashRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/d/:token" element={<GuestDiscoveryPage />} />
          <Route element={<RequireAuth />}>
            <Route path="/not-yet" element={<NotYetPage />} />
            <Route element={<RequireAllowlist />}>
              <Route element={<AuthedLayout />}>
                <Route path="/" element={<TaskListPage />} />
                <Route path="/tasks/:taskId" element={<TaskDetailPage />} />
                <Route path="/knowledge" element={<KnowledgePage />} />
                <Route path="/knowledge/:docId" element={<KnowledgeDocPage />} />
                <Route path="/discovery" element={<DiscoveryPage />} />
                {import.meta.env.DEV ? (
                  <>
                    <Route path="/previews" element={<PreviewsPage />} />
                    <Route
                      path="/previews/discovery"
                      element={<Navigate to="/discovery" replace />}
                    />
                    <Route path="/previews/campaigns" element={<CampaignsDemoPage />} />
                    <Route
                      path="/demo/discovery"
                      element={<Navigate to="/discovery" replace />}
                    />
                    <Route
                      path="/demo/campaigns"
                      element={<Navigate to="/previews/campaigns" replace />}
                    />
                  </>
                ) : null}
                <Route path="/account" element={<AccountPage />} />
              </Route>
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </HashRouter>
  )
}
